import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202603",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 9462,
  clicks: 166,
  adsSpendDollars: 662,
  budgetDollars: 14500,
  salesDollars: 2337,
  bestEstimateRoas: 3.53,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.05,
  newCustomersAcquired: 4,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
